import {
  AppleAppStoreButton,
  GooglePlayStoreButton,
} from "./../AppStoreButtons";
import { cls } from "../../../NUI/utils";

export const FooterDownload = ({ clsn }) => {
  return (
    <div className={`${clsn || ""} `}>
      <div
        className={cls(
          "text-center bg-is2-blue text-white "
        )}
      >
        <div className="flex flex-col px-6 py-24 lg:py-[120px]">
          <h2 className="mb-0">Download the app</h2>
          <p className="my-9 text-base">
            For a better experience and additional features we recommend
            downloading our app.
          </p>
          <div className="flex justify-center gap-3">
            <AppleAppStoreButton />
            <GooglePlayStoreButton />
          </div>
        </div>
      </div>
    </div>
  );
};
